@import 'styles/mixins';
@import 'styles/blaze/mixins';

.sidebar {
  display: flex;
  flex-direction: column;
  width: 230px;
  height: 100%;
  padding: 10px;
  background: var(--light-100);
  border-left: 1px solid var(--dark-4);
  overflow-y: auto;
  gap: 10px;
}

.section {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.divider {
  height: 1px;
  background: var(--dark-4);
  width: 100%;
  flex-shrink: 0;
}

.sectionLabel {
  padding-left: 8px;
}

.scheduleCard {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  border-radius: 10px;
  cursor: pointer;

  &:hover {
    background: var(--dark-2);
  }
}

.scheduleCardStatic {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  width: 100%;
  border-radius: 10px;
}

.scheduleTriggerRow {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px;
  height: 28px;
}

.scheduleTriggerText {
  font-size: 14px;
  line-height: 1.3;
  letter-spacing: 0.28px;
  color: var(--dark-80);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.quickEditsList {
  [data-autopilot-system-redesign='on'] & button,
  [data-autopilot-system-redesign='on'] & a {
    gap: 5px;
  }
}

.redesignButton {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 8px;
  border-radius: 8px;
  width: 100%;
  cursor: pointer;
  background: transparent;
  border: none;
  text-align: left;

  &:hover {
    background: var(--dark-2);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
}

.redesignButtonText {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
